import React, { useEffect, useState } from 'react';
import PageWrapper from '../../../../components/Display/PageWrapper';
import { useNavigationContext } from '../../../../contexts/NavigationContext';
import { DataView } from 'primereact/dataview';
import { privateFetch } from '../../../../utils/apiHelper';
import { useAccountContext } from '../../../../contexts/AccountContext';
import ProjectItem from './ProjectItem';
import ProjectDetail from './ProjectDetail';
import ProjectPanel from './ProjectPanel';
import ImagePanel from '../../common/image/ImagePanel';
import ReviewPanel from './Review/ReviewPanel';

function ProjectPage({ isActive }) {
  const { openCNProjectDetail, navigationContext } = useNavigationContext();
  const [projectList, setProjectList] = useState([]);
  const { accountContext } = useAccountContext();
  const [projectDetail, setProjectDetail] = useState(undefined);
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [imageManagerIsOpen, setImageManagerIsOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(undefined);
  const [selectedReview, setSelectedReview] = useState(undefined);
  const [reviewManagerIsOpen, setReviewManagerIsOpen] = useState(false);

  useEffect(() => {
    if (navigationContext.acitveProjectId) {
      fetchProjectDetail();
    } else setProjectDetail(undefined);
  }, [navigationContext]);

  useEffect(() => {
    fetchProjectList();
  }, []);

  const fetchProjectList = async () => {
    await privateFetch('GET', 'collectifnode', `/cu/${accountContext.id}/project/`).then((res) => {
      setProjectList(res);
    });
  };

  const fetchProjectDetail = async () => {
    await privateFetch(
      'GET',
      'collectifnode',
      `/cu/${accountContext.id}/project/${navigationContext.acitveProjectId}/`
    ).then((res) => {
      if (res) setProjectDetail(res);
    });
  };

  const createProject = async (projectForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'collectifnode',
      `/cu/${accountContext.id}/project/`,
      'Le projet a bien été ajouté',
      JSON.stringify(projectForm)
    ).then(() => {
      fetchProjectList();
      setPanelIsOpen(false);
      setLoading(false);
    });
  };

  const updateProject = async (projectForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'collectifnode',
      `/cu/${accountContext.id}/project/${projectDetail.id}/`,
      'Le projet a bien été modifié',
      JSON.stringify(projectForm)
    ).then(() => {
      fetchProjectList();
      setPanelIsOpen(false);
      fetchProjectDetail(projectDetail.id);
      setLoading(false);
    });
  };

  const handleDeleteProject = async (project) => {
    await privateFetch(
      'DELETE',
      'collectifnode',
      `/cu/${accountContext.id}/project/${project.id}/`,
      'Le projet a bien été supprimé'
    ).then(() => {
      fetchProjectList();
      setProjectDetail(undefined);
    });
  };

  const handleDeleteImage = async (image) => {
    await privateFetch(
      'DELETE',
      'resources',
      `/cu/${accountContext.id}/large-image/${image.id}/`,
      "L'image a bien été supprimée"
    ).then(() => {
      fetchProjectDetail();
      fetchProjectList();

      setSelectedImage(undefined);
    });
  };

  const uploadProjectImage = async (imageForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'collectifnode',
      `/cu/${accountContext.id}/project/${projectDetail.id}/image/`,
      "L'image a bien été enregistrée",
      imageForm,
      false,
      true
    ).then(() => {
      fetchProjectDetail();
      fetchProjectList();

      setLoading(false);
      setImageManagerIsOpen(false);
    });
  };

  const updateImage = async (imageForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'resources',
      `/cu/${accountContext.id}/large-image/${selectedImage.id}/`,
      "L'image a bien été modifiée",
      imageForm,
      false,
      true
    ).then(() => {
      fetchProjectDetail();
      fetchProjectList();
      setLoading(false);
      setImageManagerIsOpen(false);
    });
  };

  const handleCreateReview = () => {
    setSelectedReview(undefined);
    setReviewManagerIsOpen(true);
  };

  const handleUpdateReview = (review) => {
    setSelectedReview(review);
    setReviewManagerIsOpen(true);
  };

  const createProjectReview = async (reviewForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'collectifnode',
      `/cu/${accountContext.id}/project/${projectDetail.id}/review/`,
      'La review a bien été enregistré',
      JSON.stringify(reviewForm)
    ).then(() => {
      fetchProjectDetail(projectDetail.id);
      setLoading(false);
      setReviewManagerIsOpen(false);
    });
  };

  const updateReview = async (reviewForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'resources',
      `/cu/${accountContext.id}/review/${selectedReview.id}/`,
      "L'article a bien été modifiée",
      JSON.stringify(reviewForm)
    ).then(() => {
      fetchProjectDetail();
      setLoading(false);
      setReviewManagerIsOpen(false);
    });
  };

  const handleDeleteReview = async (review) => {
    await privateFetch(
      'DELETE',
      'resources',
      `/cu/${accountContext.id}/review/${review.id}/`,
      "L'article a bien été supprimée"
    ).then(() => {
      fetchProjectDetail();
      setSelectedReview(undefined);
    });
  };

  const handleClickProject = (project) => {
    openCNProjectDetail(project);
  };

  const handleOpenManager = () => {
    setPanelIsOpen(true);
  };

  const newProjectAction = {
    onClick: handleOpenManager,
    label: 'Ajouter un projet',
    icon: 'pi-plus'
  };

  const goBackProjectAction = {
    onClick: handleClickProject,
    label: 'Retour à la liste'
  };

  const handleCreateImage = () => {
    setSelectedImage(undefined);
    setImageManagerIsOpen(true);
  };

  const handleUpdateImage = (image) => {
    setSelectedImage(image);
    setImageManagerIsOpen(true);
  };

  const itemTemplate = (project) => (
    <ProjectItem project={project} handleClickProject={() => handleClickProject(project)} />
  );

  return (
    <div className={`h-full w-full flex-col ${isActive ? 'flex' : 'hidden'}`}>
      <PageWrapper
        label="Projets"
        labelAction={handleClickProject}
        action={projectDetail ? goBackProjectAction : newProjectAction}
        detail={projectDetail}>
        {!projectDetail ? (
          <DataView value={projectList} itemTemplate={itemTemplate} className="pb-20" />
        ) : (
          <ProjectDetail
            project={projectDetail}
            handleUpdateProject={handleOpenManager}
            handleCreateImage={handleCreateImage}
            handleUpdateImage={handleUpdateImage}
            handleDeleteImage={handleDeleteImage}
            handleDelete={handleDeleteProject}
            handleCreateReview={handleCreateReview}
            handleUpdateReview={handleUpdateReview}
            handleDeleteReview={handleDeleteReview}
          />
        )}
        <ProjectPanel
          isOpen={panelIsOpen}
          onClose={setPanelIsOpen}
          project={projectDetail}
          onCreate={createProject}
          onUpdate={updateProject}
          loading={loading}
        />
      </PageWrapper>
      <ImagePanel
        image={selectedImage}
        loading={loading}
        isOpen={imageManagerIsOpen}
        onClose={() => {
          setSelectedImage(null);
          setImageManagerIsOpen(false);
        }}
        onCreate={uploadProjectImage}
        onUpdate={updateImage}
      />
      <ReviewPanel
        review={selectedReview}
        loading={loading}
        isOpen={reviewManagerIsOpen}
        onClose={() => {
          setSelectedReview(null);
          setReviewManagerIsOpen(false);
        }}
        onCreate={createProjectReview}
        onUpdate={updateReview}
      />
    </div>
  );
}

export default ProjectPage;
